module.exports = "pegasus/assets/blocks/column-10-theme5.png";